import { Editor } from "grapesjs";

export default function IconPlugin(editor: Editor) {
  const blockManager = editor.BlockManager;
  const domComponents = editor.DomComponents;

  domComponents.addType("icon", {
    model: {
      defaults: {
        tagName: "i",
        content: "i",
      },
      updated(property: string) {
        if(property === "classes") {
          this.handleClassChange();
        }
      },
      init() {
        this.handleClassChange()
      },
      handleClassChange() {

        if(this.getAttributes().cleared === true){
          return;
        }
        
        if (this.getClasses().length > 0) {
          this.setStyle({});
          this.set("content", "");
          this.setAttributes({ cleared: true })
        } else {
          this.setStyle({
            "font-size": "1rem",
            width: "2rem",
            height: "2rem",
            background: "#EFEFEF",
            border: "1px solid #606060",
            display: "inline-block",
            "text-align": "center",
            "line-height": "2rem",
            "border-radius": "50%",
          });
          this.set("content", "i");
        }
      },
    },
  });

  blockManager.add("icon", {
    label: "Icon",
    category: "Extras",
    media: `<i class="fa-sharp fa-light fa-icons fs-2"></i>`,
    content: {
      type: "icon",
    },
  });
}
